import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-深圳发展银行",
  "use": "icon-深圳发展银行-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-深圳发展银行\"><defs><style type=\"text/css\"></style></defs><path d=\"M876.97733 760.906801v-531.345088c-5.15869-110.911839-113.491184-90.277078-113.491184-90.277078l-513.289672 5.15869c-105.753149 0-103.173804 113.491184-103.173804 113.491184v513.289672c0 123.808564 118.649874 110.911839 118.649874 110.911839h510.710328c116.070529 2.579345 100.594458-121.229219 100.594458-121.229219z m-128.967254-30.952141s-268.251889-185.712846-464.282116 23.214106l-2.579345 2.579345 2.579345-2.579345c23.214106-25.793451 193.450882-257.934509-2.579345-482.337532 0 0 250.196474 221.823678 466.861461-5.15869 0 2.579345-206.347607 245.037783 0 464.282116z\" fill=\"#0081CC\" p-id=\"1699\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/深圳发展银行.svg
// module id = At2x
// module chunks = 107